import { render, staticRenderFns } from "./AdminSessions.vue?vue&type=template&id=b15ac10c&scoped=true&"
import script from "./AdminSessions.vue?vue&type=script&lang=js&"
export * from "./AdminSessions.vue?vue&type=script&lang=js&"
import style0 from "./AdminSessions.vue?vue&type=style&index=0&id=b15ac10c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15ac10c",
  null
  
)

export default component.exports